import { Component, OnInit } from '@angular/core';
import { UserManagementAPIService } from 'src/app/Services/UserManagement/user-management-api.service';

@Component({
  selector: 'app-videos-downloads',
  templateUrl: './videos-downloads.component.html',
  styleUrls: ['./videos-downloads.component.css'],
})
export class VideosDownloadsComponent implements OnInit {
  constructor(private userManegement: UserManagementAPIService) {}

  public downloadables: Map<string, JSON> = new Map<string, JSON>();
  public fieldDownloables = 5;
  public userType = window.localStorage.getItem('userType');

  public getLast(): string {
    return Array.from(this.downloadables).sort().pop()[0];
  }

  public ngOnInit(): void {
    this.userManegement
      .getDownloableFilesByProfileType(this.userType)
      .subscribe({
        next: (data) => {
          var json = JSON.stringify(data);
          var jsonParsed = JSON.parse(json);
          var usersTypes;
          var filesGroup;
          var file;
          for (usersTypes in jsonParsed) {
            for (filesGroup in jsonParsed[usersTypes]) {
              file = jsonParsed[usersTypes][filesGroup];
              if (file.type == 'vid') {
                this.downloadables.set(file.title, file);
              }
            }
          }
        },
        error: () => {},
      });
  }
}
